import { ReactNode, useEffect } from 'react';
import { useNotifications } from '@/hooks/use-notifications';
import { useAuthContext } from '@/lib/authContext';

interface NotificationProviderProps {
  children: ReactNode;
}

export function NotificationProvider({ children }: NotificationProviderProps) {
  const { isAuthenticated, isInitialized: authInitialized } = useAuthContext();
  const { isInitialized, error } = useNotifications(isAuthenticated);

  useEffect(() => {
    if (error) {
      console.warn('Notification initialization warning:', error);
    }
  }, [error]);

  // Only initialize notifications when authenticated
  if (!authInitialized) {
    return <>{children}</>;
  }

  return <>{children}</>;
}
